module.exports = __webpack_public_path__ + "img/facebook_icon.1d435860.svg";